import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'youTransform',
  standalone: true,
})
export class YouTransformPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(
    value: { id: number; firstName: string; lastName: string },
    currentId: number
  ): string {
    if (value?.id === currentId) {
      return this.translateService.instant('UI.Common.you');
    }

    return `${value?.firstName} ${value?.lastName}`;
  }
}
